import {
  nhanVienSearchColumns,
  nhomColumns,
  QUERY_KEYS,
  regionSearchColumns,
  supplierSearchColumns,
  vatTuSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { DoiTuong, Group, KhoHang, KhuVuc, type NhanVien, VatTu } from '@/types/schemas';
import { SearchDialogActions, SearchDialogState } from '../../hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import { useLoaiVatTu } from '@/hooks/queries/useLoaiVatTu';
import { Label } from '@/components/ui/label';

interface GeneralTabProps {
  searchState: {
    state: SearchDialogState;
    actions: SearchDialogActions;
  };
}

const GeneralTab: React.FC<GeneralTabProps> = ({ searchState: { state, actions } }) => {
  const { loaiVatTus } = useLoaiVatTu();

  const loaiVatTuOptions = loaiVatTus.map(item => ({
    value: item.uuid,
    label: `${item.ten_lvt}`
  }));

  return (
    <div className='h-96 w-[800px] min-w-[800px] space-y-2 p-4'>
      {/* Mã nhà cung cấp */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Mã nhân viên</Label>
        <SearchField<NhanVien>
          searchEndpoint={`/${QUERY_KEYS.NHAN_VIEN}/`}
          searchColumns={nhanVienSearchColumns}
          dialogTitle='Danh mục nhân viên'
          columnDisplay={`ma_nhan_vien`}
          displayRelatedField={`ho_ten_nhan_vien`}
          value={state.nhanVien?.ma_nhan_vien || ''}
          relatedFieldValue={state.nhanVien?.ho_ten_nhan_vien || ''}
          onRowSelection={actions.setNhanVien}
        />
      </div>
      {/* Mã nhà cung cấp */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Mã khách hàng</Label>
        <SearchField<DoiTuong>
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={supplierSearchColumns}
          dialogTitle='Danh mục đối tượng'
          columnDisplay={`customer_code`}
          displayRelatedField={`customer_name`}
          value={state.khachHang?.customer_code || ''}
          relatedFieldValue={state.khachHang?.customer_name || ''}
          onRowSelection={actions.setKhachHang}
        />
      </div>

      {/* Nhóm nhà cung cấp - 3 field trong 1 hàng */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Nhóm khách hàng</Label>
        <div className='flex gap-3'>
          <div className='flex-1'>
            <SearchField<Group>
              searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=KH1`}
              searchColumns={nhomColumns}
              dialogTitle='Danh mục nhóm khách hàng 1'
              columnDisplay={`ma_nhom`}
              value={state.nhomKhachHang1?.ma_nhom || ''}
              relatedFieldValue={state.nhomKhachHang1?.ten_phan_nhom || ''}
              onRowSelection={actions.setNhomKhachHang1}
            />
          </div>
          <div className='flex-1'>
            <SearchField<Group>
              searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=KH2`}
              searchColumns={nhomColumns}
              dialogTitle='Danh mục nhóm khách hàng 2'
              columnDisplay={`ma_nhom`}
              value={state.nhomKhachHang2?.ma_nhom || ''}
              relatedFieldValue={state.nhomKhachHang2?.ten_phan_nhom || ''}
              onRowSelection={actions.setNhomKhachHang2}
            />
          </div>
          <div className='flex-1'>
            <SearchField<Group>
              searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=KH3`}
              searchColumns={nhomColumns}
              dialogTitle='Danh mục nhóm khách hàng 3'
              columnDisplay={`ma_nhom`}
              value={state.nhomKhachHang3?.ma_nhom || ''}
              relatedFieldValue={state.nhomKhachHang3?.ten_phan_nhom || ''}
              onRowSelection={actions.setNhomKhachHang3}
            />
          </div>
        </div>
      </div>

      {/* Khu vực */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Khu vực</Label>
        <SearchField<KhuVuc>
          searchEndpoint={`/${QUERY_KEYS.KHU_VUC}/`}
          searchColumns={regionSearchColumns}
          dialogTitle='Danh mục khu vực'
          columnDisplay={`rg_code`}
          displayRelatedField={`rgname`}
          value={state.khuVuc?.rg_code || ''}
          relatedFieldValue={state.khuVuc?.rgname || ''}
          onRowSelection={actions.setKhuVuc}
        />
      </div>

      {/* Mẫu báo cáo */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Mẫu báo cáo</Label>
        <div className='w-64'>
          <FormField
            name='mau_bc'
            type='select'
            options={[
              { value: 20, label: 'Mẫu giá trị' },
              { value: 30, label: 'Mẫu giá trị ngoại tệ' }
            ]}
            className='w-full'
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
